module.exports = __webpack_public_path__ + "static/img/discover-thumb.4cf2995.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/discover-thumb.jpg
// module id = HgJT
// module chunks = 0